// components/ui/MmInput.tsx
import React from 'react'
import { useTranslation } from 'react-i18next'

interface MmInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
}

export const MmInput: React.FC<MmInputProps> = ({
  value,
  onChange,
  placeholder,
  className = ''
}) => {
  const { t } = useTranslation('ui')
  return (
    <div className="flex items-center bg-pcg-borderStrong p-1 rounded-[10px] gap-[7px]">
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        className={`w-full h-[50px] bg-[#453E50] rounded-[8px] text-center text-[20px] font-proxima-regular text-white placeholder:text-white/60 outline-none caret-white min-[1600px]:w-[103px] ${className}`}
      />
      <span className="text-white text-[20px] font-proxima-regular">{t('mmInput.unit')}</span>
    </div>
  )
}